export function globalReach() {
    $(".global-reach svg rect, .global-reach svg path").each(function () {
        let $this = $(this);
        if ($this.data("holder")) {
            $this.addClass("pseudo-link");
        }
    });
    $(".global-reach svg .pseudo-link").hover(function () {
        $(this).css("cursor", "pointer");
        let title = $(this).data("holder");
        $('svg path[data-link="' + title + '"]').attr("fill", "#AF0B2B");
    }, function () {
        let title = $(this).data("holder");
        $('svg path[data-link="' + title + '"]').attr("fill", "#08162F");
    });
    $(".global-reach svg").on("click", ".pseudo-link", function () {
        let link = $(this).data("href");
        window.location.href = link;
    });

    let mapLink = $(".map-link");

    mapLink.focusin(function () {
        let $this = $(this);
        let title = $this.data("hidden-link");
        let mapTitle = $('svg path[data-link="' + title + '"]');
        mapTitle.attr("fill", "#AF0B2B");

    });
    mapLink.focusout(function () {
        let $this = $(this);
        let title = $this.data("hidden-link");
        $('svg path[data-link="' + title + '"]').attr("fill", "#08162F");
    });


}


// WEBPACK FOOTER //
// ./assets/js/modules/globalReach.js